import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Cookies from 'js-cookie';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Slide,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormGroup,
  Box,
  TextField,
} from '@material-ui/core';
import axios from 'axios';
import useTranslation from '../../hooks/useTranslation';
import SuccessDialog from './success';
import styles from './styles';
import globalStyles from '../layout/globalStyles';
import combineStyles from '../../utilities/combineStyles';

const SERVER_BASE_URL = process.env.REACT_APP_GRAPHQL_SERVER_BASE_URL;

const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} timeout={{ enter: 500, exit: 10 }} />);

const SurveyDialog = (props) => {
  const { t, lang } = useTranslation();
  const {
    classes, setSurveryFirstTimePopup, surveryFirstTimePopupOpen,
  } = props;
  const [isOpen, setIsOpen] = useState(true);
  const [checked, setChecked] = useState(false);
  const [randomIndex, setRandomIndex] = useState(-1);
  const [formResponse, setFormResponse] = useState({
    selectedOptions: [],
    otherText: '',
    otherChecked: false,
  });
  const [showForm, setShowForm] = useState(true);
  const [showThankYou, setShowThankYou] = useState(false);
  const [surveyStatus, setSurveyStatus] = useState(false);
  const [submitInProcess, setSubmitInProcess] = useState(false);
  const [isSurveyReady, setIsSurveyReady] = useState(false);
  const [popupOpen, setPopupOpen] = useState(surveryFirstTimePopupOpen);
  const delayInterval = {
    checkbox: 90, fullArticle: 180, close: 1, responded: 2,
  };
  const surveyLink = 'https://docs.google.com/forms/d/e/1FAIpQLScGbdTLl_PGvhXdW9auvSRBo-c5DOmgrOwQBg12AlDMru_KqA/viewform';
  const questions = [
    {
      entry: 'entry.815082507',
      question: 'How useful is the DEP for your work, on a scale of 1 to 5?',
      questionKey: 'q1_question',
      options: ['1', '2', '3', '4', '5'],
      others: false,
      multiple: false,
    },
    {
      entry: 'entry.1597726202',
      question: 'Why are you looking for evidence today? I am looking to (Please select all that apply)',
      questionKey: 'q2_question',
      options: [
        { key: 'q2_opt1', value: 'Search for studies to be included in a literature review/systematic review' },
        { key: 'q2_opt2', value: 'Inform the design of an evaluation study' },
        { key: 'q2_opt3', value: 'Gather insights useful to commission new research' },
        { key: 'q2_opt4', value: 'Inform decisions about what programmes to implement or how to implement them' },
        { key: 'q2_opt5', value: 'To inform a proposal' },
      ],
      others: true,
      multiple: true,
    },
    {
      entry: 'entry.536642882',
      question: 'How often do you use the Development Evidence Portal?',
      questionKey: 'q3_question',
      options: [
        { key: 'q3_opt1', value: 'Daily' },
        { key: 'q3_opt2', value: 'Weekly' },
        { key: 'q3_opt3', value: 'Monthly' },
        { key: 'q3_opt4', value: 'Rarely' },
        { key: 'q3_opt5', value: 'Using for the first time today' },
      ],
      others: false,
      multiple: false,
    },
    {
      entry: 'entry.1558459202',
      question: 'Which of these do you think would improve the usefulness and user experience of the DEP? (Please select all that apply)',
      questionKey: 'q4_question',
      options: [
        { key: 'q4_opt1', value: 'Better search and filter capabilities' },
        { key: 'q4_opt2', value: 'Chatbot to query study metadata (e.g., how many studies have been conducted in a particular country, how many studies have used a particular method, etc.)' },
        { key: 'q4_opt3', value: 'Chatbot to query study results (e.g., what do studies say about the effectiveness of X intervention, etc.)' },
        { key: 'q4_opt4', value: 'Interactive data visualizations/infographics about evidence for different sectors, regions, etc.' },
        { key: 'q4_opt5', value: 'Mobile friendliness' },
        { key: 'q4_opt6', value: 'Page performance (loading speed)' },
        { key: 'q4_opt7', value: 'Search interface in other languages' },
      ],
      others: true,
      multiple: true,
    },
    {
      entry: 'entry.1866596961',
      question: 'What is your current institutional affiliation? Please select all that apply.',
      questionKey: 'q5_question',
      options: [
        { key: 'q5_opt1', value: 'Government agency' },
        { key: 'q5_opt2', value: 'Academic institution' },
        { key: 'q5_opt3', value: 'Think tank and/or research institute' },
        { key: 'q5_opt4', value: 'Evaluation association-national, regional or international' },
        { key: 'q5_opt5', value: 'Multilateral organisation' },
        { key: 'q5_opt6', value: 'NGO-international' },
        { key: 'q5_opt7', value: 'NGO-national/local' },
        { key: 'q5_opt8', value: 'Consulting firm' },
        { key: 'q5_opt9', value: 'Donor agency' },
        { key: 'q5_opt10', value: 'Media' },
      ],
      others: true,
      multiple: true,
    },
  ];

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const cookieValue = Cookies.get('surveyAnswered');
    const answeredIndexes = cookieValue ? cookieValue.split(',').map(Number) : [];
    const unansweredIndexes = questions
      .map((_, index) => index)
      .filter((index) => !answeredIndexes.includes(index));

    if (unansweredIndexes.length > 0) {
      const varRandomIndex = Math.floor(Math.random() * unansweredIndexes.length);
      setRandomIndex(unansweredIndexes[varRandomIndex]);
      setIsSurveyReady(true);
    } else {
      // All questions answered — handle this case
      setPopupOpen(false);
      setRandomIndex(null); // or show a "Thank you" message
    }
  }, []);
  /* eslint-disable react-hooks/exhaustive-deps */

  if (!isSurveyReady) return null;

  if (!popupOpen && showForm) {
    return null;
  }

  const showFirstTimePopup = Cookies.get('surveyDisable');
  if (showFirstTimePopup !== undefined && showFirstTimePopup === 'Y' && showForm) {
    return null;
  }

  const disableSurvey = (duration) => {
    Cookies.set('surveyDisable', 'Y', { expires: duration });
  };

  const handleCheckbox = (event) => {
    setChecked(event.target.checked);
  };

  const handleFullSurvey = (event) => {
    event.preventDefault();
    disableSurvey(delayInterval.fullArticle);
    window.open(surveyLink, '_blank');
  };

  const markQuestionAsAnswered = (questionIndex) => {
    const cookieValue = Cookies.get('surveyAnswered');
    const answeredIndexes = cookieValue ? cookieValue.split(',').map(Number) : [];

    if (!answeredIndexes.includes(questionIndex)) {
      answeredIndexes.push(questionIndex);

      // Write it back to cookie as comma-separated string
      Cookies.set('surveyAnswered', answeredIndexes.join(','), {
        expires: 180,
        path: '/',
      });
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setSurveryFirstTimePopup(false);
    disableSurvey(checked ? delayInterval.checkbox : delayInterval.close);
  };

  const handleCheckboxChange = (option) => (event) => {
    const checkedStatus = event.target.checked;
    setFormResponse((prev) => {
      let newSelected = [...prev.selectedOptions];
      if (checkedStatus) {
        newSelected.push(option);
      } else {
        newSelected = newSelected.filter((opt) => opt !== option);
      }
      return { ...prev, selectedOptions: newSelected };
    });
  };

  const handleOtherTextChange = (e) => {
    setFormResponse({
      ...formResponse,
      otherText: e.target.value,
    });
  };

  const isSubmitEnabled = formResponse.selectedOptions.length > 0 || (formResponse.otherChecked && formResponse.otherText.trim() !== '');

  const handleSubmit = (event) => {
    event.preventDefault();
    const selectedQuestion = questions[randomIndex];

    const response = {
      question: selectedQuestion.question,
      entry: selectedQuestion.entry,
      selectedOptions: formResponse.selectedOptions,
    };

    if (formResponse.otherChecked && formResponse.otherText.trim() !== '') {
      response.otherText = formResponse.otherText;
    }

    const formAction = `${SERVER_BASE_URL}/api/survey`;

    setSubmitInProcess(true);
    axios.post(formAction, response, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(() => {
        markQuestionAsAnswered(randomIndex);
        setSurveyStatus(true);
        handleClose();
        setShowForm(false);
        setShowThankYou(true);
      })
      .catch(() => {
        setSurveyStatus(false);
        handleClose();
        setShowForm(false);
        setShowThankYou(true);
      });
  };

  return (
    <div>
      {showForm && (
        <Dialog
          open={isOpen}
          onClose={handleClose}
          className={classNames(classes.surveyDialogContainerSize)}
          TransitionComponent={Transition}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            {questions.length > 0 && randomIndex !== -1 && (
              <div className={classNames(classes.defaultDialogContainer, classes.decFirstTimeDialog)} dir={lang === 'ar' ? 'rtl' : 'ltr'} style={{ textAlign: lang === 'ar' ? 'right' : 'left' }}>
                <div className={classes.defaultAlertDialog}>
                  <h3 className={classes.modalHeading}>{t('surveyModalHeading')}</h3>
                  <Typography className={classes.modalIntroText}>
                    {t('surveyModalIntroText1')}
                    {' '}
                    <a href={surveyLink} className={classes.surveyLink} onClick={handleFullSurvey}>{t('surveyTakeFullSurvey')}</a>
                    {' '}
                    {t('surveyModalIntroText2')}
                  </Typography>

                  <div className="d-flex flex-column align-items-center">
                    {/* Form with question and radio buttons */}
                    <form className={classes.surveyForm}>
                      <Typography variant="h6" className={classes.surveyQuestion}>{t(questions[randomIndex].questionKey)}</Typography>
                      {questions[randomIndex]?.multiple ? (
                        // Multiple-choice (Checkbox)
                        <FormGroup>
                          {questions[randomIndex].options.map((option, idx) => {
                            const isString = typeof option === 'string';
                            const optValue = isString ? option : option.value;
                            const optLabel = isString ? option : t(option.key);
                            return (
                              /* eslint-disable react/no-array-index-key */
                              <FormControlLabel
                                key={idx}
                                control={(
                                  <Checkbox
                                    checked={formResponse.selectedOptions.includes(optValue)}
                                    onChange={handleCheckboxChange(optValue)}
                                    color="primary"
                                  />
                                )}
                                label={optLabel}
                                classes={{ root: classes.radioLabel }}
                              />
                              /* eslint-enable react/no-array-index-key */
                            );
                          })}

                          {/* Other checkbox */}
                          <FormControlLabel
                            control={(
                              <Checkbox
                                checked={formResponse.otherChecked}
                                color="primary"
                                onChange={(e) => {
                                  setFormResponse({
                                    ...formResponse,
                                    otherChecked: e.target.checked,
                                    // If unchecked, also clear text
                                    otherText: e.target.checked ? formResponse.otherText : '',
                                  });
                                }}
                              />
                            )}
                            label={(
                              <Box display="flex" alignItems="center">
                                <span style={{ marginInlineEnd: 8 }}>{t('otherLabel')}</span>
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  placeholder={t('pleaseSpecify')}
                                  value={formResponse.otherText}
                                  onChange={handleOtherTextChange}
                                  disabled={!formResponse.otherChecked}
                                  inputProps={{
                                    style: { paddingTop: '10px', paddingBottom: '10px' },
                                  }}
                                />
                              </Box>
                            )}
                          />
                        </FormGroup>
                      ) : (
                        <RadioGroup
                          aria-label="rating"
                          name="rating"
                          onChange={(e) => {
                            setFormResponse({
                              ...formResponse,
                              selectedOptions: [e.target.value],
                            });
                          }}
                        >
                          {questions[randomIndex].options.map((option, idx) => {
                            const isString = typeof option === 'string';
                            const optValue = isString ? option : option.value;
                            const optLabel = isString ? option : t(option.key);
                            return (
                              /* eslint-disable react/no-array-index-key */
                              <FormControlLabel
                                key={idx}
                                value={optValue}
                                control={<Radio color="primary" />}
                                label={optLabel}
                                classes={{ root: classes.radioLabel }}
                              />
                              /* eslint-enable react/no-array-index-key */
                            );
                          })}
                        </RadioGroup>
                      )}

                    </form>

                    {!submitInProcess ? (
                      <React.Fragment>
                        <div className="d-flex gap-2 mb-2">
                          <Button
                            type="button"
                            disableFocusRipple
                            color="primary"
                            onClick={handleClose}
                            className={`${classes.closeButton} ${classes.actionButton}`}
                          >
                            {t('closeButton')}
                          </Button>

                          <Button
                            type="button"
                            disableFocusRipple
                            color="primary"
                            onClick={handleSubmit}
                            className={`${classes.submitButton} ${classes.actionButton}`}
                            disabled={!isSubmitEnabled}
                          >
                            {t('submitFeedbackButton')}
                          </Button>
                        </div>

                        <FormControlLabel
                          className={classes.checkBox}
                          control={(
                            <Checkbox
                              checked={checked}
                              onChange={handleCheckbox}
                              classes={{
                                root: classes.checkBox,
                                checked: classes.checked,
                              }}
                              disableRipple
                              name="chkSurveyPopup"
                            />
                          )}
                          label={t('dontShowAgain')}
                        />
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <div
                          style={{
                            border: '0.25em solid #f3f3f3',
                            borderTop: '0.25em solid #007bff',
                            borderRadius: '50%',
                            width: '2rem',
                            height: '2rem',
                            animation: 'spin 0.8s linear infinite',
                            margin: '5px auto',
                          }}
                          role="status"
                        />
                        <style>
                          {`
                          @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                          }
                        `}
                        </style>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>
      )}
      {showThankYou && <SuccessDialog buttonText="Ok" surveyStatus={surveyStatus} />}
    </div>
  );
};

SurveyDialog.defaultProps = {
  surveryFirstTimePopupOpen: false,
  setSurveryFirstTimePopup: () => { },
};

SurveyDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  surveryFirstTimePopupOpen: PropTypes.bool,
  setSurveryFirstTimePopup: PropTypes.func,
};

const combinedStyles = combineStyles(globalStyles, styles);

export default withStyles(combinedStyles)(SurveyDialog);
